import Layout from "../../layouts";
import {Alert, AlertTitle, Paper} from "@mui/material";
import Link from "next/link";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {useState, useEffect} from "react";
import Loading from "../../components/Loading";
import Typography from "@mui/material/Typography";
import { DataGrid } from '@mui/x-data-grid';

function Index() {

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [calc, setCalc] = useState([]);

    // Pagination States
    const [rowCount, setRowCount] = useState(0);

    const columns = [
        {field: 'unit_number', headerName: 'Unidad (ECO)', flex: 1},
        {field: 'id', headerName: 'Section ID', flex: 1},
        {field: 'passengers', headerName: 'Pasajeros', flex: 1},
        {field: 'passengers_seven', headerName: 'Pasajeros (7)', flex: 1},
        {field: 'money', headerName: 'Dinero', flex: 1},
        {field: 'date', headerName: 'Fecha', flex: 1},
        {
            field: "action",
            headerName: "Action",
            sortable: false,
            renderCell: (params) => {
                return (
                    <Link href={"secciones/" + params.row.unit_id + '/' + params.row.date} passHref>
                        <Button variant="contained" target={"_blank"}>IR</Button>
                    </Link>
                );
            }
        }
    ];

    useEffect(() => {
        setRowCount((prevRowCountState) =>
            rowCount !== undefined ? rowCount : prevRowCountState,
        );
    }, [rowCount, setRowCount]);

    const retrieveSectionsIndex = async (page = 1) => {
        setLoading(true);
        let sections = await fetch(process.env.NEXT_PUBLIC_API_ENDPOINT + '/api/sections?' + new URLSearchParams({ page: page }).toString(), {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': "application/json",
            }
        });

        let json = await sections.json();
        if (json && json.data) {
            setCalc(json.data);
            setRowCount(json.total);
            console.log(json);
        } else {
            setError("No hay datos para mostrar");
        }
        setLoading(false);
    }

    useEffect(() => {
        if (calc && calc.length === 0) {
            retrieveSectionsIndex();
        }

    }, []);

    const handlePageChange = async (el) => {
        await retrieveSectionsIndex(el + 1);
    }

    return (
        <Layout>
            <Box>
                {error !== "" && (
                    <Alert severity="error">
                        <AlertTitle>No hay datos para mostrar.</AlertTitle>
                        <Link passHref href={"/tramos"}>
                            <Button variant="contained" color="error">Volver</Button>
                        </Link>
                    </Alert>
                )}
                {calc && calc.length !== 0 && (
                    <>
                        <Paper sx={{height: "auto", border: 1, borderColor: "#b0bec5"}}>
                            <Box sx={{borderBottom: 1, borderColor: "#b0bec5"}}>
                                <Typography sx={{px: 2, py: 1, fontWeight: 500}}>
                                    <strong>Tramos actuales</strong>
                                </Typography>
                            </Box>
                            <Box sx={{height: "80vh", boxShadow: 0, borderRadius: 0}}>
                                <DataGrid
                                    rows={calc}
                                    columns={columns}
                                    loading={loading}
                                    pageSize={50}
                                    rowsPerPageOptions={[50]}
                                    checkboxSelection
                                    paginationMode={"server"}
                                    rowCount={rowCount}
                                    onPageChange={(page) => handlePageChange(page)}
                                />
                            </Box>
                        </Paper>
                    </>
                )}

            </Box>
        </Layout>
    )
}

export default Index